// extracted by mini-css-extract-plugin
export var actionButton = "_8o-1";
export var actionButtons = "_8o-2";
export var actions = "_8o-0";
export var aiUnread = "_8o-10";
export var alignCenter = "_8o-h";
export var backWrapper = "_8o-3";
export var cellContainer = "_8o-4";
export var checkboxContainer = "_8o-5";
export var contentContainer = "_8o-6";
export var contentHeader = "_8o-8";
export var conversationsTableWrapper = "_8o-s";
export var draftReplyBadgeContainer = "_8o-m";
export var dropdownItem = "_8o-b";
export var dropdownItemsContainer = "_8o-a";
export var dropdownTitle = "_8o-c";
export var errorIcon = "_8o-7";
export var filter = "_8o-d";
export var gray = "_8o-i";
export var headerActionButtons = "_8o-e";
export var headerCheckboxContainer = "_8o-f";
export var icon = "_8o-j";
export var menuContainer = "_8o-k";
export var noMoreTicketsIcon = "_8o-12";
export var noMoreTicketsSubText = "_8o-13";
export var oneLine = "_8o-l";
export var optionsButton = "_8o-n";
export var plus = "_8o-o";
export var portalButtonsWrapper = "_8o-g";
export var red = "_8o-p";
export var scrolledTop = "_8o-9";
export var search = "_8o-q";
export var selectedConversationsCount = "_8o-r";
export var spinner = "_8o-t";
export var strong = "_8o-u";
export var summaryCell = "_8o-v";
export var tableContainer = "_8o-11";
export var tagContainer = "_8o-w";
export var threeDots = "_8o-x";
export var twoLines = "_8o-y";
export var unread = "_8o-z";